import { useLocalStorage } from '#pplx/frontend/browser-storage/hooks/useLocalStorage.js';
export const usePersistentPromoCode = () => {
    const [value, setValue] = useLocalStorage('pplx.persistent_promo_code', null);
    return [value, setValue];
};
//# sourceMappingURL=usePersistentPromoCode.js.map